import * as z$1 from "zod/v4";
//#region src/schemas/agent-view/structured-guide.ts
const STRUCTURED_GUIDE_SCHEMA_VERSION = 1;
const dualViewGuideInputSchema = z$1.strictObject({
	summary: z$1.string().min(1),
	humanSteps: z$1.array(z$1.string()),
	agentRequiredArgs: z$1.array(z$1.string()).optional(),
	agentOptionalArgs: z$1.array(z$1.string()).optional(),
	agentCommands: z$1.array(z$1.string()).optional(),
	notes: z$1.array(z$1.string()).optional()
});
const structuredGuidePayloadSchema = z$1.strictObject({
	schemaVersion: z$1.literal(1),
	summary: z$1.string().min(1),
	forAgents: z$1.strictObject({
		requiredArguments: z$1.array(z$1.string()),
		optionalArguments: z$1.array(z$1.string()),
		commands: z$1.array(z$1.string()),
		notes: z$1.array(z$1.string())
	}),
	forHumans: z$1.strictObject({ steps: z$1.array(z$1.string()) })
});
/**
* Builds a stable structured payload:
* optional agent arrays are normalized to `[]`, and schemaVersion is always present.
*/
const structuredGuidePayloadFromInputSchema = dualViewGuideInputSchema.transform((guide) => ({
	schemaVersion: 1,
	summary: guide.summary,
	forAgents: {
		requiredArguments: guide.agentRequiredArgs ?? [],
		optionalArguments: guide.agentOptionalArgs ?? [],
		commands: guide.agentCommands ?? [],
		notes: guide.notes ?? []
	},
	forHumans: { steps: guide.humanSteps }
})).pipe(structuredGuidePayloadSchema);
//#endregion
export { STRUCTURED_GUIDE_SCHEMA_VERSION, dualViewGuideInputSchema, structuredGuidePayloadFromInputSchema, structuredGuidePayloadSchema };

//# sourceMappingURL=structured-guide.js.map